<template>
  <div class="dialog_warp" style="padding-top: 0;">
    <el-form class="dialog_form" ref="info" :model="info" :rules="rule" size="small" label-width="100px">
      <el-row>
        <el-col :span="16" :offset="4">
          <el-form-item label="反馈标题：" prop="feedTitle">
            <el-input v-model.trim="info.feedTitle" placeholder="请输入反馈标题"></el-input>
          </el-form-item>
          <el-form-item label="类型：" prop="feedType">
            <el-select v-model.trim="info.feedType" placeholder="请选择类型">
              <el-option v-for="(item,index) in feedbackTypeList" :key="item.feedbackTypeId" :label="item.feedbackTypeName"
                       :value="item.feedbackTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理反馈：" prop="feedContent">
            <el-input type="textarea" v-model.trim="info.feedContent" placeholder="请输入反馈内容" :rows="4"></el-input>
          </el-form-item>
          <el-form-item label="内容图片：">
            <div class="flex-box">
              <v-upload-file :number="3" :size="20" :img="true" :list="fileList"
                             @onFileChange="onFileChange"></v-upload-file>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="text-right" style="margin-top: 20px;">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button size="small" type="success" @click="submit" :loading="submitLoading">确 认</el-button>
    </div>
  </div>
</template>

<script>
  import * as getData from '../../service/getData'
  import * as global from '../../config/mUtils'

  export default {
    data() {
      return {
        info: {
          feedTitle: '',
          feedContent: '',
          feedType: '',
          backFiles: [],
        },
        problemInfo: {
          handleBack: ''
        },
        rule: {
          feedTitle: [
            {required: true, message: '请输入反馈标题', trigger: ['blur', 'change']},
            {max: 20, message: '反馈标题不能超过20个字符', trigger: ['blur', 'change']},
          ],
          feedType: [
            {required: true, message: '请选择类型', trigger: ['blur', 'change']},
          ],
          feedContent: [
            {required: true, message: '请输入反馈内容', trigger: ['blur', 'change']},
            {max: 200, message: '反馈内容不能超过200个字符', trigger: ['blur', 'change']},
          ],
        },
        fileList: [],
        imgUrl: '',
        lookBigImgDialog: false,
        submitLoading: false,
        imgArr: [],
        feedbackTypeList:[],
      }
    },
    created() {
    },
    mounted() {
      this.init();
      this.getFeedbackTypes();
    },
    props: ['type', 'id'],
    computed: {},
    methods: {
      close(type) {
        if (type === 1) {
          this.$emit('init')
        }
        this.$emit('closeDialog')
      },
      onFileChange(obj) {
        this.fileList = obj.fileList ? obj.fileList : [];

      },
      getFeedbackTypes(){
        getData.getFeedbackTypes().then((res) => {
          if (res.data.code != 'success') {
            this.$message({
              type: 'error',
              message: res.data.message || res.data.Msg
            });
            return
          }
          this.feedbackTypeList = res.data.data.feedbackTypes;
        }).catch(_ => {
          this.resourceListLoading = false;
        })
      },
      submit() {
        this.$refs['info'].validate((valid) => {
          if (valid) {
            this.fileList.forEach((item, index) => {
              this.info.backFiles.push(item.imgUrl)
            });
            getData.addFeedback(this.info.feedType, this.info.feedTitle, this.info.feedContent, this.info.backFiles).then(res => {
              if (res.data.code === 1) {
                this.$message.success('提交成功！')
                this.submitLoading = false;
                this.info.feedContent = ''
                this.info.feedTitle = ''
                this.info.feedType = [];
                this.info.fileList = [];
                this.close(1);
              } else {
                this.$message.error(res.data.message)
              }
            }).catch(_ => {
              this.submitLoading = false;
              this.$message.warning('新增失败！')
            })
          } else {
            this.$message({
              type: 'warning',
              message: '请认真检查一下！'
            })
          }
        })
      },
      init() {

      },
    },
    components: {},
    watch: {}
  }
</script>
<style scoped lang="scss">
  @import '../../assets/css/mixin';

  .input-title {
    font-size: 10px;
    line-height: 32px;
    padding-left: 10px;
  }

  .dialog-form {
    box-sizing: border-box;
    border: 1px solid $border-c;
  }

  .select-account {
    .el-dialog--center .el-dialog__body {
      padding: 0;
    }
  }

  .problem-header {
    justify-content: space-between;
    .title {
      font-size: 14px;
      font-weight: 700;
    }
  }

  .problem-img {
    width: 54px;
    height: 54px;
  }

  .g-tag {
    width: 83px;
    height: 30px;
    margin-right: -10px;
    text-align: center;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    background: #169bd5;
    span {
      font-size: 13px;
      line-height: 33px;
      color: #fff;
    }
  }

  .g-tag.danger {
    background: #ff3300;
    color: #fff;
  }

  .problem-content, .problem-handle-content {
    /*margin-top: 10px;*/
    min-height: 90px;
    padding: 20px;
    font-size: 13px;
    word-break: break-all;
    border-top: 1px solid $border-c;
    img {
      width: 132px;
      height: 82px;
    }
  }

  .img-type {
    width: 100px;
    height: 100px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/信息反馈/问题反馈添加.vue